import { Surface } from "../../../surface/primitives/surface";
import { EventsWebsocketService } from "../../../../services/entities/events-websocket.service";
import { Entity } from "src/app/state/entities/entity.model";
import { degToRad, generateUUID } from "three/src/math/MathUtils.js";
import { renderContent, renderLayoutContainer } from "./create-surface";
import { SurfaceService } from "src/app/binst/surface/surface.service";
import { Rect } from "src/app/binst/primitives/rect";
import { Blueprint } from "../i-blueprint";
import { Vector3 } from "three/src/math/Vector3.js";
import { Vector2 } from "three/src/math/Vector2.js";
import { entityActions } from "src/app/state/entities/entity.actions";
import { Store } from "@ngrx/store";
import { CameraState } from "src/app/state/camera/camera.state";
import { selectCameraState } from "src/app/state/camera/camera.selector";
import { PointerTracker } from "src/app/binst/inputs/primitives/pointer-tracker";
import { Container } from "pixi.js";
import { BlueprintServices } from "../blueprint-service-holder.service";

export const flyers: Map<string, Flyer> = new Map();

export class Flyer implements Blueprint {
  id = generateUUID();
  entity: Entity;
  surface: Surface;
  container: Container;
  isMoving = false;
  websocketService: EventsWebsocketService;
  camera: CameraState;

  async found(config: {
    entity: Entity;
    blueprintServices: BlueprintServices
    store: Store;
  }) {
    return this.instance(config);
  }

  async created(config: {
    entity: Entity;
    blueprintServices: BlueprintServices
    store: Store;
  }) {
    return this.instance(config);
  }

  async instance(config: {
    entity: Entity;
    blueprintServices: BlueprintServices
    store: Store;
  }) {
    config.store.select(selectCameraState).subscribe((cameraState) => {
      this.camera = cameraState;
    });
    this.entity = config.entity;
    this.id = config.entity.id;
    // this.container = await renderLayoutContainer(
    //   this.entity,
    //   config.surfaceService,
    // );
    // this.surface = await config.surfaceService.create(
    //   new Rect(0, 0, this.container.width, this.container.height),
    // );
    // this.surface.stage.addChild(this.container);
    // this.surface.rect.onMove(this.move.bind(this));
    // this.surface.rect.onHover(this.hover.bind(this));
    // this.surface.mesh.position.x = this.entity.coord.x;
    // this.surface.mesh.position.y = this.entity.coord.y;
    // this.surface.mesh.position.z = this.entity.coord.z;
    // await renderContent({
    //   surface: this.surface,
    //   surfaceService: config.surfaceService,
    //   entity: this.entity,
    //   container: this.container,
    // });
  }

  async move(pos: Vector2) {
    const dist = this.camera.zoom;
    const zeta = dist / 50000;
    const multFactor = 0.001;
    console.log(`zeta: ${zeta} mult: ${multFactor}`);
    const mult = Math.sin(Math.sin(Math.sin(Math.pow(zeta, 1)))) * 0.4;
    this.surface.mesh.position.x += pos.x * mult;
    this.surface.mesh.position.y -= pos.y * mult;
    const pos2d = new Vector2(
      this.surface.mesh.position.x,
      this.surface.mesh.position.y,
    );
    this.websocketService.dispatch(
      entityActions.netMoved({
        entityId: this.id,
        oldPos: this.surface.mesh.position,
        newPos: new Vector3(pos2d.x, pos2d.y, 5),
      }),
    );
    this.isMoving = true;
    clearTimeout(this.unsetMovingDebouncerTimeout);
    this.unsetMovingDebouncerTimeout = setTimeout(
      this.unsetMoving.bind(this),
      1000,
    );
  }

  async updatePosition(config: {
    entity: Entity;
    oldPos: Vector3;
    newPos: Vector3;
    blueprintServices: BlueprintServices
  }) {
    if (!this.isMoving) {
      this.surface.mesh.position.x = config.newPos.x;
      this.surface.mesh.position.y = config.newPos.y;
    }
  }

  unsetMoving() {
    this.isMoving = false;
  }

  unsetMovingDebouncerTimeout: NodeJS.Timeout = null;

  hover(pointer: PointerTracker) {
    const modx = -0.5 + pointer.relPos.y / this.surface.rect.height;
    const mody = -0.5 + pointer.relPos.x / this.surface.rect.width;
    const insideRect = Rect.FromUnitRect(
      this.surface.rect,
      Rect.FromLTRB(
        3 * (1 - Math.abs(modx)),
        4 * (1 - Math.abs(mody)),
        100 - 3 * (1 - Math.abs(modx)),
        100 - 4 * (1 - Math.abs(mody)),
      ),
    );
    if (insideRect.intersectsPoint(pointer.relPos)) {
      this.surface.mesh.rotation.y = degToRad(mody) * 40;
      this.surface.mesh.rotation.x = degToRad(modx) * 40;
    }
    // if (!this.rotateOnce) {
    //   this.rotateOnce = true
    //   this.twRotation.stop()
    //   this.twRotation.to({
    //     z: 50,
    //   }, 250).startFromCurrentValues()
    // }
    return false;
  }
}
